import React, { Component } from 'react';
import { post } from '../utils/request';
import queryString from 'query-string';
import { wxShare, isWeChat, deleteUrlKey } from '../utils/util';

// component
import Banner from '../components/banner';
import Login from '../components/login';
import Intro from '../components/intro';
import TopDom from '../components/top';
import Dialog from '../components/dialog';
import AttService from '../components/attentionService';
import ConfirmTickets from '../components/confirmTickets';
import CourseReCom from '../components/courseRecommend';
import SignButton from '../components/signInButton';
import { UserInfoCon } from '../components/groupPerson';
import { ProjectCon } from '../components/groupProject';
import { OtherInfo, PickTickets } from '../components/groupOther';

// css
import '../assets/css/tickets.scss';

class Class extends Component {
  constructor (props) {
    super(props)
    // 报名表信息
    this.state = {
      allInfoRight: true, // 表单底部校验信息是否完全提示
      checkErr: false, // 检测表单数据
      endGetPage: false, // 页面基本信息获取完毕
      hasLogin: false, // 默认没登录的情况下不会出现表单
      currentPageInfo: {}, // 页面基础信息
      endGetUserInfo: false, // 页面表单信息获取完毕
      userInfo: {}, // 用户基本信息和项目信息
      TicketData: {}, // 选票信息
      showServiceDialog: false, // 展示服务号关注二维码
      showRepeatDialog: false, // 购票确认弹层
      wechatDialogJson: {}, // 服务号传送json
      commitFlag: true
    }
    
    // login组件信息
    this.loginInfo = {
      urlValues: '',
      userLoginInfo: {}
    };

    // 其他问题组件
    this.resApplyData = {
      answers: []
    };
  }
  componentDidMount () {
    const urlValues = queryString.parse(this.props.location.search);
    this.pageUrlValues = urlValues;
    this.loginInfo.urlValues = urlValues; // 传值给login组件
    this.getPageInfo();
    window.addEventListener('scroll', this.handelScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handelScroll);
  }
  handelScroll = () => {
    const t = document.documentElement.scrollTop || document.body.scrollTop;
    const top_view = document.getElementsByClassName('sign-fix-button')[0];
    const intro_view = document.getElementById('form-start');
    if (top_view && top_view !== null && intro_view && intro_view !== null) {
      top_view.style.display = t >= (intro_view.offsetTop - 500) ? 'none' : 'block';
    }
  }
  getPageInfo = () => {
    post('/fancube/apply/apply_info/', {
      "code": this.pageUrlValues.acid
    })
    .then(res => {
      if (res.code === 200) {
        // set title
        if (res.data.apply_title) {
          document.title = res.data.apply_title
        }
        wxShare(res.data.apply_title, '小饭桌，预见未来商业领袖');
        // storage
        localStorage.removeItem('formPageSto');
        localStorage.setItem('formPageSto', JSON.stringify({
          banner: res.data.top_pc_banner,
          from: 'conference',
          title: res.data.apply_title,
          shareUrl: deleteUrlKey('code')
        }))
        // change state
        this.setState({
          currentPageInfo: res.data,
          isCourseOut: new Date(res.data.date) < new Date(),
          endGetPage: 'end'
        })
      }
    })
  }
  getUserInfo = (phone) => {
    post('/fancube/apply/v2/meeting/en/', {
      "code": this.pageUrlValues.acid,
      "phone": phone
    })
    .then(res => {
      if (res.code === 200) {
        if (res.data.apply) {
          this.state.currentPageInfo["answers"] = res.data.apply.answers;
        }
        this.setState({
          userInfo: res.data,
          currentPageInfo: this.state.currentPageInfo,
          endGetUserInfo: 'end'
        })
      }
    })
  }
  getUserData = (resPonUserData) => {
    this.setState({
      resPonUserData
    })
  }
  getProjectData = (resProjectData) => {
    this.setState({
      resProjectData
    })
  }
  getApplyData = (resApplyData) => {
    this.resApplyData = resApplyData;
  }
  getTicketData = (resTicketData) => {
    this.setState({
      TicketData: resTicketData
    });
  }
  getAttService = (resAttService) => {
    this.setState({
      subscribe: resAttService.subscribe
    })
  }
  getConfirmTickets = (resComTickets) => {
    // 确认购买 不需要审核的票 点击确定购票后 直接跳转到支付页面
    if (resComTickets.isSure) {
      sessionStorage.setItem("courseback", window.location.origin + '/form/success'); 
      let payUrl = window.location.origin + '/order/pay/?id=' + this.state.TicketData.product_id + '&num=1';
      if (isWeChat()) {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${window.formGlobalData.appId}&redirect_uri=` + encodeURIComponent(payUrl) + '&response_type=code&scope=snsapi_base&state=state#wechat_redirect';
      } else {
        window.location.href = payUrl;
      }
    } else {
      this.setState({
        showRepeatDialog: false
      })
    }
  }
  getLoginData = (resLoginData) => {
    this.resLoginData = resLoginData;
    this.setState({
      hasLogin: resLoginData.hasLogin,
      openId: resLoginData.openid
    },() => {
      if (this.state.hasLogin) {
        // 登录成功后获取页面个人信息
        this.getUserInfo(resLoginData.userLoginInfo.phone);
        // 传参给服务号二维码组件
        let wechatDialogJson = {
          'code': this.pageUrlValues.acid
        }
        if (isWeChat() && this.state.openId ) {
          wechatDialogJson['openid'] = this.state.openId;
        }
        this.setState({
          wechatDialogJson: wechatDialogJson
        })
      }
    })
  }
  ajaxPartner = () => {
    let vendorVal = sessionStorage.getItem('UserVendor') && sessionStorage.getItem('UserVendor') !== null && sessionStorage.getItem('UserVendor') !== 'null' ? sessionStorage.getItem('UserVendor') : '';
    post('/fancube/apply/v2/meeting/submit/', {
      "project": this.state.resProjectData,
      "entrepreneur": this.state.resPonUserData,
      "apply": {
        "product_id": this.state.TicketData.product_id,
        "answers": this.resApplyData.answers,
        "code": this.pageUrlValues.acid,
        "channel": this.pageUrlValues.channel
      },
      "uid": this.resLoginData.userLoginInfo.uid,
      "vendor": vendorVal
    }).then(res => {
      this.setState({
        commitFlag: true
      })
      if (res.code === 200) {
        // 需要审核的票 或者 没有票的情况下
        if ((this.state.TicketData.review && this.state.TicketData.product_id) || !!!this.state.TicketData.product_id) {
          // 没有关注服务号的情况
          if (!!!this.state.subscribe) {
            this.setState({
              showServiceDialog: true
            })
          }
          // 已经关注服务号
          else {
            const { history } = this.props;
            const location = {
              pathname: '/success'
            }
            history.push(location);
          }
        } else if(this.state.TicketData.product_id) {
          // 不需要审核的票种
          if (this.state.TicketData) {
            this.setState({
              showRepeatDialog: true
            })
          }
        }
      }
    })
  }
  ajaxSubmitData = () => {
    this.state.resPonUserData.position = this.state.resProjectData.position;
    if (this.state.resPonUserData.isRight && this.state.resProjectData.isRight && this.state.commitFlag) {
      this.setState({
        commitFlag: true
      })
      this.ajaxPartner();
    }
  }
  handleSubmit = () => {
    this.setState({
      checkErr: true
    })
    this.ajaxSubmitData();
  }
  render () {
    let changeJson = {};
    if (this.state.endGetUserInfo && this.state.userInfo.entrepreneur) {
      changeJson = {
        "position": this.state.userInfo.entrepreneur.position
      };
    }
    
    return (
      <div className="class-wrapper page-wrapper">
        { 
          this.state.endGetPage &&
          <div className="end-wrapper">
            <TopDom />
            <Banner url={this.state.currentPageInfo.top_pc_banner} />
            <Intro {...this.state.currentPageInfo} isShowValue={this.pageUrlValues} notShowPositionTips={true} />
            {
             this.state.isCourseOut ? <CourseReCom/> : <Login {...this.loginInfo} type={this.state.currentPageInfo.type} receiveData={this.getLoginData} />
            }
            {
              this.state.hasLogin && this.state.endGetUserInfo &&
              <div className="form-info-wrapper">
                <PickTickets tickets={this.state.currentPageInfo.tickets} receiveData={ this.getTicketData }/>
                <UserInfoCon { ...this.state.userInfo.entrepreneur } checkErr={ this.state.checkErr } receiveData={ this.getUserData } />
                <ProjectCon { ... this.state.userInfo.project } { ... changeJson } checkErr={ this.state.checkErr } receiveData={ this.getProjectData } />
                { 
                  this.state.currentPageInfo && this.state.currentPageInfo.questions && this.state.currentPageInfo.questions.length > 0 && 
                  <OtherInfo { ... this.state.currentPageInfo } receiveData={ this.getApplyData } />
                }
                <Dialog isShow={ this.state.showServiceDialog }>
                  <AttService receiveData={ this.getAttService } { ...this.state.wechatDialogJson } isShowDia={ this.state.showServiceDialog } history={ this.props.history }/>
                </Dialog>
                
                <Dialog isShow={ this.state.showRepeatDialog }>
                  <ConfirmTickets { ...this.state.TicketData } receiveData={ this.getConfirmTickets } />
                </Dialog>
                { this.state.checkErr && (!this.state.resPonUserData.isRight || !this.state.resProjectData.isRight) && <p className="err-bottom-tips">请完善相关资料</p>}
                <div className={this.state.commitFlag ? "submit-form l-button" : "submit-form l-button disabled"} onClick={ this.handleSubmit }>{this.state.commitFlag ? '提交' : '正在提交...'}</div>
              </div>
            }
          </div>
        }
        { this.pageUrlValues && this.pageUrlValues.intro && <SignButton scrollId="form-start" isCourse={this.state.isCourseOut ? true : false}/> }
      </div>
    )
  }
}
export default Class;